import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStrokeDropDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M160 414L458 736C471 750 485 756 500 756C515 756 528 751 542 736L836 418C877 374 863 328 812 328H188C140 328 122 370 160 414ZM250 400H750L500 671Z" })
});
export default SvgStrokeDropDown;
